import React from 'react'
import Spinner from 'components/Spinner'
import Rounds from './Steps/Rounds'
import TimeSlots from './Steps/TimeSlots'
import GameConstraint from './Steps/GameConstraint'
import TravelConstraint from './Steps/TravelConstraint'
import { Button, Row } from 'antd'

interface LeagueStep5Props {
  handleNext: () => void
  handleBack: () => void
}

const Step5: React.FC<LeagueStep5Props> = ({ handleNext, handleBack }) => {
  return (
    <div>
      {false ? (
        <div className="py-40px flex justify-center">
          <Spinner />
        </div>
      ) : (
        <>
          <div className="mt-20px">
            <Rounds />
          </div>
          <div className="mt-20px">
            <TimeSlots />
          </div>
          <div className="mt-20px">
            <GameConstraint />
          </div>
          <div className="mt-20px">
            <TravelConstraint />
          </div>
          <Row justify="space-between" className="mb-26 mt-40px">
            <Button className="cancel-button" onClick={handleBack}>
              Back
            </Button>
            <Button className="stepper-button" onClick={handleNext}>
              Next
            </Button>
          </Row>
        </>
      )}
    </div>
  )
}

export default Step5
